import { API_ENDPOINTS } from '../config';

/**
 * Generate an insurance PDF for a collection and have it emailed to the
 * specified recipient. The backend handles PDF generation and email sending
 * and returns a simple success/error response.
 */
export async function generateInsurancePdf(
  token: string, 
  collectionId: number,
  recipientName: string,
  recipientEmail: string
): Promise<void> {
  const url = API_ENDPOINTS.GENERATE_COLLECTION_INSURANCE_PDF(collectionId);

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      recipient_name: recipientName,
      recipient_email: recipientEmail,
    }),
  });

  if (!response.ok) {
    let message = 'Failed to generate insurance PDF.';
    try {
      const data = await response.json();
      if (data && data.error) {
        message = data.error;
      }
    } catch {
      // ignore JSON parsing errors and use default message
    }
    throw new Error(message);
  }
}
